var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.607 12.003a.526.526 0 01-.472-.291 6.589 6.589 0 011.234-7.624 6.606 6.606 0 019.332 0 .528.528 0 01-.746.746A5.55 5.55 0 003.56 7.869a5.536 5.536 0 00.52 3.37.527.527 0 01-.472.764zM9.035 15.35a6.577 6.577 0 01-4.666-1.93.528.528 0 01.746-.746 5.55 5.55 0 009.396-3.035 5.536 5.536 0 00-.519-3.37.527.527 0 11.943-.473 6.596 6.596 0 01-5.9 9.554z",
    fill: "#042A2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.081 5.212a.527.527 0 01-.051-1.052l1.667-.166-.334-1.676a.528.528 0 011.034-.206l.448 2.247a.527.527 0 01-.465.628l-2.246.224h-.053zM5.19 15.82a.528.528 0 01-.518-.424l-.447-2.246a.527.527 0 01.465-.628l2.245-.224a.527.527 0 01.106 1.05l-1.668.166.334 1.676a.527.527 0 01-.518.63z",
    fill: "#042A2A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
var MemoForwardRef = /*#__PURE__*/React.memo(ForwardRef);
export default __webpack_public_path__ + "assets/refreshIcon.3771ecc5.svg";
export { MemoForwardRef as ReactComponent };